var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewlogoicn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.333,
    height: 47.165,
    viewBox: "0 0 37.333 47.165",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.75)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 5.363)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.284,0H21.693L32.841,9.863v27.9a3.284,3.284,0,0,1-3.284,3.284H3.284A3.284,3.284,0,0,1,0,37.767V3.284A3.284,3.284,0,0,1,3.284,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.284,1.5A1.786,1.786,0,0,0,1.5,3.284V37.767a1.786,1.786,0,0,0,1.784,1.784H29.557a1.786,1.786,0,0,0,1.784-1.784V10.538L21.125,1.5H3.284m0-1.5H21.693L32.841,9.863v27.9a3.284,3.284,0,0,1-3.284,3.284H3.284A3.284,3.284,0,0,1,0,37.767V3.284A3.284,3.284,0,0,1,3.284,0Z",
    fill: "#2769ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.824,12.068H3.594A3.594,3.594,0,0,1,0,8.474V.64S13.809,12.068,11.824,12.068Z",
    transform: "translate(20.822 -0.64)",
    fill: "#2769ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.635,11.268A68.629,68.629,0,0,0,5.2,6.132C3.538,4.671,1.894,3.274.8,2.352V8.474a2.8,2.8,0,0,0,2.794,2.794h7.041m1.189.8H3.594A3.594,3.594,0,0,1,0,8.474V.64S13.809,12.068,11.824,12.068Z",
    transform: "translate(20.822 -0.64)",
    fill: "#2769ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.245.75H0A.75.75,0,0,1-.75,0,.75.75,0,0,1,0-.75H18.245A.75.75,0,0,1,19,0,.75.75,0,0,1,18.245.75Z",
    transform: "translate(7.602 20.526)",
    fill: "#2769ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.245.75H0A.75.75,0,0,1-.75,0,.75.75,0,0,1,0-.75H18.245A.75.75,0,0,1,19,0,.75.75,0,0,1,18.245.75Z",
    transform: "translate(7.602 26.608)",
    fill: "#2769ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.123.75H0A.75.75,0,0,1-.75,0,.75.75,0,0,1,0-.75H9.123a.75.75,0,0,1,.75.75A.75.75,0,0,1,9.123.75Z",
    transform: "translate(7.602 32.69)",
    fill: "#2769ff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.251,11.751A.75.75,0,0,1,9.5,11,9.512,9.512,0,0,0,0,1.5.75.75,0,0,1-.75.75.75.75,0,0,1,0,0,10.928,10.928,0,0,1,7.779,3.222,10.929,10.929,0,0,1,11,11,.75.75,0,0,1,10.251,11.751Z",
    transform: "translate(26.333 -0.75)",
    fill: "#2769ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.674,20.174a.75.75,0,0,1-.75-.75A5.93,5.93,0,0,0,0,13.5a.75.75,0,0,1-.75-.75A.75.75,0,0,1,0,12a7.432,7.432,0,0,1,7.424,7.424A.75.75,0,0,1,6.674,20.174Z",
    transform: "translate(26.333 -9.172)",
    fill: "#2769ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.1,28.6a.75.75,0,0,1-.75-.75A2.349,2.349,0,0,0,0,25.5a.75.75,0,0,1-.75-.75A.75.75,0,0,1,0,24a3.851,3.851,0,0,1,3.847,3.847A.75.75,0,0,1,3.1,28.6Z",
    transform: "translate(26.333 -17.596)",
    fill: "#2769ff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewlogoicn);
export default __webpack_public_path__ + "static/media/newlogoicn.01c4f4785d099ba782387aa71b47322e.svg";
export { ForwardRef as ReactComponent };